<template>
  <Grid :gtr="`32px ${active ? '60px' : '40px'} 32px`" justify-items="center" align-items="center" gap="10px">
    <div
      class="label"
      :class="active ? 'text-body-4 text-secondary-2' : 'text-body-1 text-secondary-1'"
      :style="{ gridRow: labelBottom ? 3 : 1 }"
    >
      {{ label }}
    </div>

    <Grid
      place-items="center"
      class="round-icon shadow-low"
      :class="[{ active }, milestone.status]"
      @click.native="!loading && $emit('click')"
    >
      <q-spinner v-if="loading" color="secondary-2" size="18px" />
      <i v-else-if="milestone.status !== 'not_reached'" :class="iconClass"></i>
    </Grid>
  </Grid>
</template>

<script>
import { STATUS_DICTIONARY } from '@/mixins/milestones.mixin'

export default {
  props: {
    labelBottom: Boolean,
    active: Boolean,
    loading: Boolean,
    icon: String,
    milestone: {
      type: Object,
      required: true
    }
  },

  computed: {
    label() {
      return this.milestone.status_date
        ? `${this.milestone.name} \n ${this.formatDateForLocale(this.milestone.status_date)}`
        : this.milestone.name
    },

    iconClass() {
      return STATUS_DICTIONARY[this.milestone.status].icon
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  white-space: pre-line;
  text-align: center;
}

.round-icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
  grid-row: 2;
  background: var(--r-white-4);
  border-radius: 50%;
  color: var(--r-white-1);
  transition: all 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6);

  &.active {
    width: 60px;
    height: 60px;
  }

  &.completed {
    background: var(--r-grey-3);
  }

  &.pending {
    background: var(--r-primary-1);
  }

  &.dismissed {
    background: var(--r-danger-1);
  }
}
</style>
